import { Concepto } from "./concepto";
import { Prevision } from "./Prevision";

export interface PedidoDetalle {
  id: number;
  identificador?: string;
  id_centro_logistico: number;
  id_proveedor: number;
  numero?: string;
  fecha?: string;
  tipo_documento: number;
  ind_iberado: number;
  numero_proveedor?: string;
  comprador?: string;
  condicion_uso_cfdi?: string;
  condicion_forma_pago?: string;
  condicion_metodo_pago?: string;
  estatus_descripcion: number;
  estatus: number;
  tipo_cambio: number;
  moneda?: string;
  monto_total: number;
  terminos_pago?: string;
  terminos_entrega?: string;
  indicador_anticipo?: string;
  fecha_vencimiento_anticipo?: string;
  importe_anticipo: number;
  correo_anticipo?: string;
  suma_anticipo: number;
  ruta_pdf?: string;
  fecha_creacion?: string;
  fecha_actualizacion?: string;
  usuario_creacion?: string;
  usuario_actualizacion?: string;
  centro_logistico_codigo?: string;
  proveedor_nombre?: string;
  empresa?: string;
  sucursal?: string;
  anticipo_completado: boolean;
  empresa_codigo?: string;
  empresa_rfc?: string;
  proveedor_correo?: string;
  proveedor_rfc?: string;
  restante_anticipo?: string;
}
export interface Partidas {
  id: number;
  id_orden_compra: number;
  pocision: number;
  material?: string;
  material_descripcion?: string;
  hotel_clave: any;
  fecha_entrega: any;
  cantidad: number;
  unidad?: string;
  precio_unitario: number;
  precio_neto: number;
  precio_bruto: number;
  fecha_creacion?: string;
  fecha_actualizacion?: string;
  usuario_creacion?: string;
  usuario_actualizacion?: string;
  delete_indicador: number;
  no_more_gr: any;
  ordenCompra: any;
  cantidad_entregada: number;
  cantidad_pendiente: number;
  entregado: boolean;
  selectedConceptos: Array<Concepto>;
}

export interface Recepcion {
  id: number;
  identificador?: string;
  id_orden_compra: number;
  codigo_recepcion: number;
  fecha_documento: any;
  fecha_contable: any;
  nota_entrega: any;
  activo: any;
  facturado: any;
  movimiento: any;
  monto: number;
  ruta_pdf?: string;
  fecha_creacion: any;
  fecha_actualizacion: any;
  usuario_creacion?: string;
  usuario_actualizacion?: string;
  num_orden_compra: number;
  proveedor?: string;
  rfc_proveedor: any;
  empresa?: string;
  empresa_codigo: number;
  sucursal?: string;
  sucursal_codigo: number;
}

export interface BalancePedido {
  tota_orden_compra: number;
  total_anticipo: number;
  total_anticipo_facturado: number;
  total_codigos_recepcion_entregado: number;
  total_codigos_recepcion_facturado: number;
  total_saldo_pendiente: number;
}

export interface HistorialEntradasMercancia {
  activo: boolean;
  codigo_recepcion?: string;
  doc_folio_sap?: string;
  doc_pagado: boolean;
  doc_ruta_pdf?: string;
  doc_ruta_xml?: string;
  empresa?: string;
  empresa_codigo?: string;
  facturado: boolean;
  fecha_actualizacion?: string;
  fecha_contable?: string;
  fecha_creacion?: string;
  fecha_documento?: string;
  id: number;
  id_orden_compra: number;
  identificador?: string;
  monto: number;
  movimiento?: string;
  nota_entrega?: string;
  num_orden_compra?: string;
  proveedor?: string;
  rfc_proveedor?: string;
  ruta_pdf?: string;
  sucursal?: string;
  sucursal_codigo?: string;
  usuario_actualizacion?: string;
  usuario_creacion?: string;
  uuid?: string;
  id_comprobante?: number;
  prevision?: Prevision;
  identificador_comprobante?: string;
}

export class RequestCargaDocumentosPedido {
  codigos_recepcion: string[];
  concepto_partidas: any[];
  id_orden_compra?: string;
  list_ids_crs: number[];
  pdf_base64?: string;
  xml_base64?: string;

  constructor() {
    this.codigos_recepcion = [];
    this.concepto_partidas = [];
    this.id_orden_compra = '';
    this.list_ids_crs = [];
    this.pdf_base64 = '';
    this.xml_base64 = '';
  }
}
